<template>
  <div class="main-container">
    <div class="main-container__menu" :class="menuClasses">
      <div
        v-for="(item, index) of menuItems"
        :id="item.id"
        :key="index"
        class="main-container__menu__item"
        :class="{
          active: getIsActive(item),
        }"
        @click="onClickItem(item)"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
import { getIsMobileOrTablet } from '@/utils/misc';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'MenuSectionsLanding',
  data() {
    return {
      selectedItemId: '',
      playsTypeOptions: ['goals', 'bestPlays'],
      summaryRoutesNames: ['player', 'team'],
    };
  },
  computed: {
    ...mapState('mediaGeneral', ['initialDataForLandingButton', 'player']),
    ...mapState('loginGeneral', ['tournaments']),
    ...mapGetters('loginGeneral', [
      'getUser',
      'isPlayer',
      'getURL',
      'getSeasons',
      'getTournaments',
      'getTournamentSelected',
      'getSeasons',
      'getSeasonSelected',
      'showDashboard',
    ]),
    ...mapGetters('mediaGeneral', ['isPlayerGoalkeeper']),
    mediaPlayerType() {
      return this.summaryRoutesNames.includes(this.$route.name) ? 'summary' : 'general';
    },
    hasActiveTime() {
      return false; //this.getUser.active_time === 1;
    },
    menuClasses() {
      return [getIsMobileOrTablet() ? 'main-container__menu--is-mobile' : ''];
    },
    menuItems() {
      if (Object.keys(this.tournaments).length) {
        const hasActiveTime = false; //this.getUser.active_time === 1;
        const menuItems = [
          { id: 'vt', name: 'Ver todo', mainRoute: { name: 'landing' }, routesNames: ['landing'] },
          {
            id: 'ca',
            name: 'Calendario',
            mainRoute: { name: 'extended-calendar' },
            routesNames: ['extended-calendar'],
          },
          { id: 'vi', name: 'Videos', mainRoute: { name: '' }, routesNames: [] },
          { id: 'ta', name: 'Tabla', mainRoute: { name: 'table' }, routesNames: ['table'] },
          { id: 'dg', name: 'Datos GolStats', mainRoute: { name: 'golStatsData' }, routesNames: ['golStatsData'] },
          { id: 'mj', name: 'Mejores Jugadores', mainRoute: { name: 'tops' }, routesNames: ['tops'] },
          {
            id: 'ju',
            name: 'Jugadores',
            mainRoute: { name: 'playerTeams' },
            routesNames: ['playerTeams', 'players', 'player'],
          },
          { id: 'eq', name: 'Equipos', mainRoute: { name: 'teams' }, routesNames: ['teams', 'team'] },
          { id: 'gs', name: 'GS 1.0' },
        ];
        const routeData = this.getRouteData('me');
        const menuItem = {
          id: 'me',
          name: hasActiveTime ? 'Tiempo \nefectivo' : this.isPlayer ? 'Mi perfil' : 'Mi equipo',
          routesNames: routeData ? routeData.routesNames : [],
        };
        if (hasActiveTime) {
          menuItems.splice(1, 0, menuItem);
        } else if (this.getUser.show_dashboard) {
          menuItems.unshift(menuItem);
        }
        return menuItems;
      }
      return [];
    },
  },
  watch: {
    '$route.name'(newValue) {
      const menuItem = this.menuItems.find(menuItem => {
        return menuItem.mainRoute && menuItem.mainRoute.name === newValue;
      });
      if (menuItem && this.selectedItemId !== menuItem.id) {
        this.selectedItemId = menuItem.id;
      } else {
        this.selectedItemId = '';
      }
    },
  },
  methods: {
    ...mapActions('loginGeneral', [
      'storeTournamentSelected',
      'storeSeasonSelected',
      'storeTournamentNameSelected',
      'storeSeasonNameSelected',
    ]),
    getIsActive(item) {
      if (this.$route.query.section) {
        return this.$route.query.section === item.id;
      }
      return item.routesNames && item.routesNames.includes(this.$route.name);
    },
    getRouteData() {
      if (this.hasActiveTime) {
        return {
          routesNames: ['activeTime'],
        };
      } else {
        return null;
      }
    },

    onClickTeam(section) {
      if (this.hasActiveTime) {
        this.$router.push({
          name: 'activeTime',
        });
      } else {
        if (!this.showDashboard) {
          return;
        }
        if (this.getUser.player !== 0) {
          if (
            Object.values(this.getUser.related_seasons).indexOf(this.getSeasonSelected) > -1 ||
            this.getSeasonSelected === this.getUser.season
          ) {
            this.$router.push({
              name: 'player',
              params: {
                seasonId: this.getSeasonSelected,
                playerId: this.getUser.player,
              },
              query: {
                section,
              },
            });
          } else {
            this.storeTournamentSelected(this.getUser.tournament);
            this.storeTournamentNameSelected(this.getTournaments[this.getUser.tournament].name);
            this.storeSeasonNameSelected(this.getSeasons[this.getUser.tournament][' ' + this.getUser.season].name);
            this.storeSeasonSelected(this.getSeasons[this.getUser.tournament][' ' + this.getUser.season].id);
            this.$router.push({
              name: 'player',
              params: {
                seasonId: this.getSeasonSelected,
                playerId: this.getUser.player,
              },
              query: {
                section,
              },
            });
          }
        } else {
          let tournamentSelect = this.getUser.tournament;
          if (this.getUser.type_system === 'seleccion') {
            if (this.getTournamentSelected !== 33) {
              tournamentSelect = 33;
              const nowMillis = new Date().getTime();
              const qatarEnabledDayMillis = new Date('2022-11-21T03:59:00.000Z').getTime();
              this.storeTournamentSelected(tournamentSelect);
              this.storeTournamentNameSelected(this.getTournaments[tournamentSelect].name);
              this.storeSeasonNameSelected(
                this.getSeasons[tournamentSelect][
                  Object.keys(this.getSeasons[tournamentSelect])[nowMillis >= qatarEnabledDayMillis ? 0 : 1]
                ].name,
              );
              this.storeSeasonSelected(
                Object.keys(this.getSeasons[tournamentSelect])[nowMillis >= qatarEnabledDayMillis ? 0 : 1].slice(1),
              );
            }
          } else {
            this.storeTournamentSelected(tournamentSelect);
            this.storeTournamentNameSelected(this.getTournaments[tournamentSelect].name);
            this.storeSeasonNameSelected(
              this.getSeasons[tournamentSelect][Object.keys(this.getSeasons[tournamentSelect])[0]].name,
            );
            this.storeSeasonSelected(Object.keys(this.getSeasons[tournamentSelect])[0].slice(1));
          }
          setTimeout(() => {
            this.$router.push({
              name: 'team',
              params: {
                teamId: this.getUser.team,
              },
              query: {
                section,
              },
            });
          }, 200);
        }
      }
    },
    openMediaPlayer() {
      const modalInitialState = {
        seasonId: this.initialDataForLandingButton[this.mediaPlayerType].seasonId,
        tournaments: this.initialDataForLandingButton[this.mediaPlayerType].tournamentsForModalLauncher,
        categoryIds: [...this.initialDataForLandingButton[this.mediaPlayerType].currentCategories],
        mainSectionType: 1,
        playListType: this.initialDataForLandingButton[this.mediaPlayerType].selectedType,
        matchResult: [1, 2, 3],
        currentPlayIndex: this.initialDataForLandingButton[this.mediaPlayerType].playlistIndex,
        isFromLandingButton: true,
      };
      const player = this.initialDataForLandingButton[this.mediaPlayerType].player;
      if (player) {
        const playerId = player.player_id || player.id;
        if (player.position_name === 'Portero' || player.positionId === 1) {
          modalInitialState.goalkeeperIds = [playerId];
        } else {
          modalInitialState.playerIds = [playerId];
        }
      } else if (this.initialDataForLandingButton[this.mediaPlayerType].teamId) {
        modalInitialState.teamId = this.initialDataForLandingButton[this.mediaPlayerType].teamId;
      }
      this.$store.commit('mediaModal/setModalInitialState', modalInitialState);
      this.$store.commit('mediaModal/setIsModalOpen', true);
    },
    onClickItem(item) {
      if (item.id === 'ca') {
        if (this.$route.name !== item.mainRoute.name) {
          this.$router.push(item.mainRoute);
        }
      } else if (item.id === 'gs') {
        window.open(this.getURL);
      } else if (item.id === 'vi') {
        this.openMediaPlayer();
      } else if (this.selectedItemId !== item.id) {
        this.selectedItemId = item.id;
        if (item.id === 'me') {
          this.onClickTeam('me');
        } else {
          this.$router.push(item.mainRoute);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.main-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  &__menu {
    width: 1270px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    padding-bottom: 6px;

    &--is-mobile {
      -webkit-overflow-scrolling: touch;
      /* Hide scroll bar in firefox*/
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    &__item {
      padding: 8px 24px 4px;
      border-radius: 25px;
      background-color: rgba(203, 238, 109, 0.5);
      white-space: nowrap;
      color: #132739;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.06;
      letter-spacing: -0.16px;
      cursor: pointer;

      &.active {
        border: solid 2px #111f2c;
        background-color: rgba(203, 238, 109, 0.5);
      }
    }
  }

  @media screen and (max-width: 1326px) {
    overflow-x: auto;
    overflow-y: hidden;

    &__menu {
      width: calc(100vw - 32px);
      overflow-x: auto;
      overflow-y: hidden;

      &__item {
        margin: 0 4px;
      }
    }
  }
}

#me {
  @media screen and (max-width: 480px) {
    display: none !important;
  }
}
::-webkit-scrollbar {
  height: 4px;
}

/* Track */
::-webkit-scrollbar-track {
  //box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Handle */

::-webkit-scrollbar-thumb {
  background: #e5e7ec;
  border-radius: 10px;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #e5e7ec;
}
</style>
